import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Formatodc3Component } from './formatodc3/formatodc3.component';
import { LoginComponent } from './pages/login/login.component';
import {FmtcelenmisionComponent} from './pages/fmtcelenmision/fmtcelenmision.component'
import { InicioComponent } from './pages/inicio/inicio.component';
import { RasciComponent } from './pages/rasci/rasci.component';
import { CvComponent } from './pages/cv/cv.component';
import { AreaComponent } from './pages/area/area.component';
import { ProcesoComponent } from './pages/proceso/proceso.component';
import { OrgComponent } from './pages/org/org.component';
import { OrgLComponent } from './pages/leady/org-l/org-l.component';
import { RoleComponent } from './pages/role/role.component';
import { RptPerComponent } from './pages/rpt-per/rpt-per.component';
import { CrmReportesComponent } from './pages/crm-reportes/crm-reportes.component';
import { ClienteComponent } from './pages/cliente/cliente.component';
import { CompetenciaComponent } from './pages/competencia/competencia.component';
import { Format1Component } from './pages/format1/format1.component';
import { ServiciosComponent } from './pages/servicios/servicios.component';
import { FormatRaciComponent } from './pages/format-raci/format-raci.component';
import { FormatServiceComponent } from './pages/format-service/format-service.component';
import { TaketimeComponent } from './pages/taketime/taketime.component';
import { Raci2Component } from './pages/raci2/raci2.component';
import { HkComponent } from './pages/hk/hk.component';
import { RegistroComponent } from './pages/registro/registro.component';
import { FmthkComponent } from './pages/fmthk/fmthk.component';
import { AssesmentComponent } from './pages/assesment/assesment.component';
import { FmtcharterComponent } from './pages/fmtcharter/fmtcharter.component';
import { HojatrabajoComponent } from './pages/hojatrabajo/hojatrabajo.component'; 
import { FmthtComponent } from './pages/fmtht/fmtht.component'; 
import { DespliegueComponent } from './pages/despliegue/despliegue.component'; 
import { FmtdespliegueComponent } from './pages/fmtdespliegue/fmtdespliegue.component'; 
import { DdfComponent } from './pages/ddf/ddf.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { UsuarioComponent } from './pages/usuario/usuario.component';
import { ClientesComponent } from './pages/clientes/clientes.component';
import { SeguimientoClienteComponent } from './pages/seguimiento-cliente/seguimiento-cliente.component';
import { PreventaComponent } from './pages/preventa/preventa.component';
import { TaskComponent } from './pages/task/task.component';
import { FmttaskComponent } from './pages/fmttask/fmttask.component';
import { CelenComponent } from './pages/celen/celen.component';
import { CelenfmtComponent } from './pages/celenfmt/celenfmt.component';
import { RolecardComponent } from './pages/rolecard/rolecard.component';
import { PersonaComponent } from './pages/persona/persona.component';
import { ListaClienteComponent } from './pages/lista-cliente/lista-cliente.component';
import { ListaClienteLComponent} from './pages/leady/lista-cliente-l/lista-cliente-l.component';
import { NuevoclienteComponent } from './pages/nuevocliente/nuevocliente.component';
import { EstructuraComponent } from './pages/estructura/estructura.component';
import { TasktestComponent } from './pages/tasktest/tasktest.component';
import { TicketComponent } from './pages/ticket/ticket.component';
import { Listaclientesv2Component } from './pages/listaclientesv2/listaclientesv2.component';
import { EmpleadosComponent } from './pages/empleados/empleados.component';
import { EntidadComponent } from './pages/entidad/entidad.component';
import { EscolaridadComponent } from './pages/escolaridad/escolaridad.component';
import { InstitucionComponent } from './pages/institucion/institucion.component';
import { ProbatorioComponent } from './pages/probatorio/probatorio.component';
import { WscliComponent } from './pages/wscli/wscli.component';
import { CalendarTaskComponent } from './pages/calendar-task/calendar-task.component';
import { AtenderticketComponent } from './pages/atenderticket/atenderticket.component';
import { PerfilComponent } from './pages/perfil/perfil.component';
import { PginicioComponent } from './pages/pginicio/pginicio.component';
import { InicioLeadyComponent } from './pages/leady/inicio-leady/inicio-leady.component';
import { Frmdc3Component } from './pages/formas/frmdc3/frmdc3.component';
import { FmtdiaComponent } from './pages/fmtdia/fmtdia.component';
import { FrmentrenamientoComponent} from './pages/formas/frmentrenamiento/frmentrenamiento.component'
import { FrmmultihabilidadComponent} from './pages/formas/frmmultihabilidad/frmmultihabilidad.component'

import { DocumentofinalComponent } from './pages/documentofinal/documentofinal.component';
import { FmtdocumentofinalComponent } from './pages/fmtdocumentofinal/fmtdocumentofinal.component';
import { RacivdocComponent } from './pages/racivdoc/racivdoc.component';
import { HtvdocComponent } from './pages/htvdoc/htvdoc.component';
import { FrmmatpuecurComponent } from './pages/formas/frmmatpuecur/frmmatpuecur.component';
import { ListaDdfComponent } from './pages/lista-ddf/lista-ddf.component';
import { Ddf2Component } from './pages/ddf2/ddf2.component';
import { CursosComponent } from './pages/cursos/cursos.component';
const routes: Routes = [
  { path: '', component: LoginComponent },  
  { path: 'entrenamiento', component:FrmentrenamientoComponent }, 
  { path: 'multihabilidad', component:FrmmultihabilidadComponent }, 
  { path: 'login', component: LoginComponent },  
  { path: 'raciv2', component: RasciComponent },  
  { path: 'raci2', component: Raci2Component },  
  { path: 'lddf', component: ListaDdfComponent},
  { path: 'pdf', component: Formatodc3Component },  
  { path: 'rolec', component: CvComponent },  
  { path: 'Support', component: AreaComponent }, 
  { path: 'DC3', component: Frmdc3Component },  
  { path: 'task-', component: ProcesoComponent },  
  { path: 'org', component: OrgComponent }, 
  { path: 'org_leady', component: OrgLComponent }, 
  { path: 'role', component: RoleComponent }, 
  { path: 'rptp', component: RptPerComponent }, 
  { path: 'ticket', component: TicketComponent },  
  { path: 'ddf2', component: Ddf2Component },  
  { path: 'atenderticket', component: AtenderticketComponent },  
  { path: 'competences',component:CompetenciaComponent},
  { path: 'wscli',component:WscliComponent}, 
  { path: 'cliente',component:ListaClienteComponent},
  { path: 'empleados',component:EmpleadosComponent},
  { path: 'editacliente',component:ClienteComponent},
  { path: 'entidad',component:EntidadComponent},
  { path: 'dfinal',component:DocumentofinalComponent},
  { path: 'fmtdfinal',component:FmtdocumentofinalComponent},
  { path: 'calendar_task',component:CalendarTaskComponent},
  { path: 'escolaridad',component:EscolaridadComponent},
  { path: 'institucion',component:InstitucionComponent},
  { path: 'probatorio',component:ProbatorioComponent},
  { path: 'nuevocliente',component:NuevoclienteComponent},
  { path: 'lista_cliente',component:ListaClienteComponent},
  { path: 'lista_cliente_leady',component:ListaClienteLComponent},
  { path: 'lista_clientev2',component:Listaclientesv2Component},
  { path: 'crms_reportes', component: CrmReportesComponent }, 
  { path: 'estructura', component: EstructuraComponent }, 
  { path: 'fmt112', component: Format1Component }, 
  { path: 'serviciosv1', component: ServiciosComponent },
  { path: 'perfil', component: PerfilComponent }, 
  { path: 'iniciopg', component: PginicioComponent }, 
  { path: 'inicio_leady', component: InicioLeadyComponent }, 
  
  { path:'fmtcelenmision',component:FmtcelenmisionComponent },
  { path: 'fmt2', component: FormatRaciComponent }, 
  { path: 'tasktest', component: TasktestComponent }, 
  { path: 'fmt3', component: FormatServiceComponent }, 
  { path: 'taketime', component: TaketimeComponent }, 
  { path: 'hkv2', component: HkComponent }, 
  { path: 'hk', component: HkComponent }, 
  { path: 'registro', component: RegistroComponent }, 
  { path: 'fmt_hk', component: FmthkComponent }, 
  { path: 'ht', component: HojatrabajoComponent }, 
  { path: 'preventa', component: PreventaComponent }, 
  { path: 'puestocurso', component: FrmmatpuecurComponent }, 
  { path: 'racivdoc', component: RacivdocComponent },
  { path: 'htvdoc', component: HtvdocComponent },
  { path: 'seguimiento_clientev3', component: SeguimientoClienteComponent },
  { path: 'assesment',component:AssesmentComponent},
  { path: 'fmtht',component:FmthtComponent},  
  { path: 'fmtdia',component:FmtdiaComponent},    
  { path:'fmtcharter',component:FmtcharterComponent},
  { path:'despliegue',component:DespliegueComponent},
  { path:'fmtdespliegue',component:FmtdespliegueComponent},
  { path:'ddf',component:DdfComponent},
  { path: 'calendarv2', component: CalendarComponent },   
  { path: 'crm_clientes', component: ClientesComponent },
  { path: 'usuario', component: UsuarioComponent },
  { path: 'task', component: TaskComponent },  
  { path: 'fmttask', component: FmttaskComponent },   
  { path: 'celen', component: CelenComponent },  
  { path: 'celenfmt', component: CelenfmtComponent },  
  { path: 'rolecard', component: RolecardComponent },  
  { path: 'persona', component: PersonaComponent },  
  { path: 'cursos', component: CursosComponent },  
  
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


